import clsx from 'clsx'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'

import { TServiceVariant } from '@/features/product-services/lib/types'

import { BASE_URL } from '@/shared/lib/const/env'
import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Button } from '@/shared/ui'

import cl from './ProductServiceCard.module.scss'

export type ProductServiceCardProps = {
	onActivityChange?: (isActive: boolean) => void
	isActive?: boolean
	count?: number
	price?: number
	onCountChange?: (newCount: number) => void
	borderBottom?: boolean
	bonusScore?: number
	maxCount?: number
	hasActiveService?: boolean
	onApply?: (id: number) => void
	PRODUCT_ID?: number
} & TServiceVariant

export const ProductServiceCard = ({
	TITLE,
	DESCRIPTION = [],
	DETAIL_PICTURE,
	onCountChange,
	onActivityChange,
	count,
	price,
	isActive = false,
	maxCount,
	hasActiveService,
	onApply,
	PRODUCT_ID
}: ProductServiceCardProps): JSX.Element => {
	const [isChecked, setChecked] = useState(isActive)
	const [isLoading, setLoading] = useState<boolean>(false)

	useEffect(() => {
		setChecked(isActive)
	}, [isActive])

	useEffect(() => {
		if (count && maxCount && maxCount < count && onCountChange) {
			onCountChange(maxCount)
		}
	}, [count, maxCount, onCountChange])

	const toggleActive = () => {
		const newActiveState = !isChecked
		setChecked(newActiveState)
		setLoading(true)
		if (!!onActivityChange) onActivityChange(newActiveState)
		setTimeout(() => {
			setLoading(false)
		}, 1000)
	}

	return (
		<article className={clsx(cl.root, cl.serviceCard, { [cl.disabled]: !isChecked && hasActiveService })}>
			<div className={cl.imageWrapper}>
				{!!DETAIL_PICTURE && (
					<Image alt={TITLE} src={BASE_URL + DETAIL_PICTURE} width={304} height={170} className={cl.image} />
				)}
			</div>
			<p className={cl.title}>{TITLE}</p>
			{!!DESCRIPTION?.length && (
				<ul className={cl.list}>
					{DESCRIPTION.map((item, index) => (
						<li key={index} className={cl.listItem}>
							{item}
						</li>
					))}
				</ul>
			)}

			<div className={cl.bottom}>
				<p className={cl.price}>
					{!!price && <span>{formatPrice(price, `decimal`)} ₽</span>}
					Стоимость
				</p>

				{onApply && PRODUCT_ID ? (
					<Button className={cl.orderButton} onClick={() => onApply?.(PRODUCT_ID)}>
						Оформить с картой
					</Button>
				) : (
					<Button
						className={cl.addToCartButton}
						onClick={toggleActive}
						disabled={isLoading}
						theme={isChecked ? 'outlined' : 'primary'}>
						{isChecked ? 'Убрать' : 'Добавить'}
					</Button>
				)}
			</div>
		</article>
	)
}
